import React from "react";
import { filterAllowedColumn } from "../../_helper/helper";
import moment from "moment";
import { Avatar, Chip, Typography } from "@mui/material";
export const RemarksLogs = ({
  transactionProcessStatuses,
  application = null,
}) => {
  let textRemarks;
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  const sortedAuditTrail = JSON.parse(
    JSON.stringify(transactionProcessStatuses)
  ).filter((item) => {
    const dateCompleted = item?.dateCompleted
      ? new Date(item.dateCompleted)
      : null;
    return dateCompleted ? dateCompleted > oneYearAgo : false;
  });
  // .sort((a, b) => new Date(b.dateCompleted) - new Date(a.dateCompleted));

  if (sortedAuditTrail.length > 0) {
    const {
      statusRemarks: remarks,
      // employeeName,
      status,
      dateCompleted: resultDateComplete,
      finalStatus,
    } = sortedAuditTrail?.slice(-1)?.[0] || {};
    const dateCompleted = moment(resultDateComplete);
    if (!dateCompleted.isValid()) {
      console.error("Invalid dateCompleted date");
      return;
    }

    const secondLastElement =
      transactionProcessStatuses?.length === 0
        ? { employeeName: "" }
        : transactionProcessStatuses?.length === 1
        ? transactionProcessStatuses?.[0]
        : transactionProcessStatuses?.[transactionProcessStatuses?.length - 2];

    const { employeeName } = secondLastElement;

    const { status: currentStatus, statusRemarks } =
      transactionProcessStatuses?.slice(-1)?.[0] ?? {};
    // console.log(currentStatus,'sortedAuditTrail1221')

    console.log("sdlfjksjdfdf", currentStatus);

    const CalDate = (endDate) => {
      const now = moment();
      const duration = moment.duration(now.diff(endDate));
      const years = duration.years();
      const months = duration.months();
      const days = duration.days();
      const hours = duration.hours();
      const mins = duration.minutes();
      const secs = duration.seconds();

      let message = "";
      if (years > 0) {
        message += `${years} years, `;
      }
      if (months > 0 || years > 0) {
        message += `${months} months, `;
      }
      if (days > 0) {
        message += `${days} days, `;
      }
      message += `${hours} hours, ${mins} min, ${secs} sec ago`;

      return message;
    };

    // const text = CalDate(dateCompleted);
    const text = moment(dateCompleted, "MMDDYYYY").fromNow();
    const isApproved =
      currentStatus?.toLowerCase().includes("approved to supervisor review") ||
      currentStatus?.toLowerCase().includes("approved to agency director") ||
      (application && currentStatus?.toLowerCase().includes("approved"));
    const isReturned = currentStatus?.toLowerCase().includes("returned");
    // console.log(status,status?.toLowerCase()=='approved',isApproved,sortedAuditTrail,'isApprovedStatus')

    textRemarks =
      isApproved || isReturned ? (
        <div style={{ width: "inherit" }}>
          <div
            style={{
              borderLeft: isApproved
                ? "5px solid #41ed41"
                : isReturned
                ? "5px solid red"
                : "none",
              padding: "10px",
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
            }}
          >
            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <Avatar sx={{ bgcolor: "var(--theme-default)" }}>
                {employeeName?.charAt(0)}
              </Avatar>
              <Typography
                variant="subtitle2"
                fontWeight={700}
                sx={{ textTransform: "capitalize" }}
              >
                {employeeName}
              </Typography>
              <Chip
                label={isApproved ? "Approved" : isReturned ? "Returned" : null}
                color={isApproved ? "success" : isReturned ? "error" : "info"}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              <div>
                <Typography
                  variant="body1"
                  sx={{ textTransform: "capitalize" }}
                >
                  Remark
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    textTransform: "capitalize",
                    fontStyle: "italic",
                    marginLeft: "5px",
                  }}
                >
                  {statusRemarks ? statusRemarks : ""}
                </Typography>
              </div>
            </div>
            <Typography variant="caption" color={"GrayText"}>
              {dateCompleted
                ? moment(dateCompleted).format("MMMM Do YYYY, h:mm a")
                : "N/A"}
              .
            </Typography>
          </div>
        </div>
      ) : null;
    return textRemarks;
  }

  return <div>{textRemarks} </div>;
};
export const loadingPanel = () => {
  return (
    <div
      className="k-loading-mask"
      style={{
        position: `fixed`,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
      }}
    >
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );
};

export const LoadingPanel = ({ position = "fixed" }) => {
  return (
    <div
      className="k-loading-mask"
      style={{
        position: position,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
      }}
    >
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );
};
export function findMaxDigitsAmongFields(data, fields) {
  let maxDigits = 0;

  data &&
    data.length > 0 &&
    data.forEach((item) => {
      fields.forEach((field) => {
        const value = item[field];
        if (typeof value === "number") {
          const numDigits = value.toString().replace(".", "").length;
          if (numDigits > maxDigits) {
            maxDigits = numDigits;
          }
        }
      });
    });

  return maxDigits;
}
export const ConcatenedColumns = (
  columns,
  HistoryColumns,
  setSortedColumns,
  userData
) => {
  if (columns && HistoryColumns.length > 0 && columns.length > 0) {
    const clms = HistoryColumns.map((d) => d.field.toLowerCase());
    const data = columns
      .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
      .map((p) => {
        return {
          field:
            p.column_name.indexOf("_") > -1
              ? p.column_name
                  .slice(0, p.column_name.indexOf("_") - 1)
                  .toLowerCase() +
                p.column_name.slice(p.column_name.indexOf("_") - 1)
              : p.column_name.charAt(0).toLowerCase() + p.column_name.slice(1),
          show: false,
          locked: false,
          width: 200,
          title: p.column_title,
          filter: "text",
        };
      });

    const sortedData = filterAllowedColumn(
      userData,
      HistoryColumns.concat(data),
      "id"
    );

    setSortedColumns(sortedData);
  }
};
export const sortingFunc = (sortData, historyData, setHistoryData) => {
  const data = [...historyData].sort((a, b) => {
    return sortData
      .map((sortItem) => {
        const { field, dir } = sortItem;
        if (a[field] < b[field]) return dir === "desc" ? 1 : -1;
        if (a[field] > b[field]) return dir === "desc" ? -1 : 1;
        return 0;
      })
      .reduce((acc, result) => {
        return acc !== 0 ? acc : result;
      }, 0);
  });

  setHistoryData(data);
};
